module.exports = __webpack_public_path__ + "static/media/qrcode.e082c733.svg";